import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Container, Row, Col, Table, Button } from 'reactstrap';
import authService from '../api-authorization/AuthorizeService';
import AdminFunctions from './AdminFunctions';
import Session from '../auth/Session'


function Roles(props) {

    const navigate = useNavigate();
    useEffect(() => {
        fetchIsAdmin()
        
    }, [])

    async function fetchIsAdmin() {
        const isAdmin = await AdminFunctions.isAdminAsync();
        if (!isAdmin) {
            navigate('/accessdenied');
        } else {
            getRoles();
        }

    }

    const [roles, setRoles] = useState([]);


    const getRoles = async () => {
        const token = Session.getToken();
        const response = await fetch(`api/Admin/GetRolesAsync`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        setRoles(data);
    }

    const handleRowClick = (roleId) => {
        navigate({
            pathname: '/admin/roles/details',
            state: { roleId: roleId, existingRole: true }
        });
    }

    return (
        <div>
            <Container style={{ marginTop: '50px' }}>
                <Row>
                    <Col xl='10' lg='10' md='10' sm='10' xs='10'>
                        <h3>Roles</h3>
                    </Col>
                    <Col xl='2' lg='2' md='2' sm='2' xs='2'>
                        <Button
                            color='primary'
                            onClick={() => navigate('/admin/roles/create')}
                            style={{ whiteSpace: 'nowrap' }}
                        >
                            + Add
                        </Button>
                    </Col>
                </Row>
                <Row style={{ marginTop: '20px' }}>
                    <Col>
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {roles.map((role, i) => {
                                    return (
                                        <tr
                                            key={role.id}
                                            onClick={() => handleRowClick(role.id)}
                                        >
                                            <td>{role.id}</td>
                                            <td>{role.name}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Roles;

